import React, { useEffect, useState } from "react";
import CommonTable from "../Common/Components/CommonTable";
import {
  deleteUser,
  getUserDetails,
  getState,
  getUserStatus
} from "../apiSection/apiUrlConstent";
import Loading from "../Common/Components/Loading";
import ToggleDrawer from "../Common/Components/ToggleDrawer";
import CreateUser from "./CreateUser";
import Input from "../Common/Components/InputField";
import { useForm } from "react-hook-form";
import CustomModal from "../Common/Components/modal";
import ActionButton from "../Common/Components/Button";
import service from "../apiSection/service";
import { ShowAlert } from "../Common/Components/Alert";
import CustomSelect from "../Common/Components/Select";
import { useSelector } from "react-redux";
import { makeStyles } from "@mui/styles";

const columns = [
  { id: "sNo", label: "S.NO", align: "center" },
  { id: "FName", label: "Name", align: "left" },
  { id: "email", label: "Email", align: "left" },
  { id: "mobile", label: "Mobile Number", align: "left" },
  { id: "created_on", label: "Created Date", align: "left" },
  { id: "role_name", label: "Department", align: "left" },
  { id: "last_login_time", label: "Last Login", align: "left" },
  { id: "user_status_id", label: " User Status", align: "left" },
  { id: "menuIcon", label: "Action", align: "left" },
];
const useStyles = makeStyles(() => ({
  body: {
    justifyContent: "space-between",
    marginBottom: "10px",
    display: "flex",
    alignItems: "center",
  },
  alignment: {
    display: "flex",
    justifyContent: "space-between",
    alignContent: "center",
    marginTop: "10px",
  },
  font: { fontWeight: "600" },
  color: { color: "blue" },
  heading: { color: "#707EAE", fontWeight: "600" },
  selectStyle: { display: "flex", gap: "15px" },
}));

export default function UserList(props) {
  const { control, register, setValue } = useForm();
  const [searchValue, setSearchValue] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [paginationData, setPaginationData] = useState({
    pageNo: 0,
    size: 10,
    search: false,
    searchVal: "",
  });
  const defaultStatus = "Active";
  const [filters, setFilters] = useState({
    search_string: "",
    user_id: 0,
    start_date: "",
    end_date: "",
    status: defaultStatus
  });
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [userId, setUserId] = useState(null);
  const [user, setUser] = useState(null);
  const [render, setRender] = useState(null);
  const [stateData, setStateData] = useState("");
  const [userStatus, setUserStatus] = useState("");

  const classes = useStyles();

  useEffect(() => {
    handleStateData();
    handleUserStatusData();
  }, []);

  useEffect(() => {
    setUser(null);
    if (isOpen) {
      const postData = {
        search_string: "",
        user_id: userId,
        page: 1,
        per_page: 25,
        start_date: "",
        end_date: "",
        status: defaultStatus,
        state_id: 0
      };
      service.create(getUserDetails, postData).then((res) => {
        setUser(res?.data?.result?.list[0]);
      });
    }
  }, [userId, isOpen]);

  const toggleDrawer = (open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return; // Ignore Tab and Shift key events
    }
    setIsOpen(open); // Update the state
  };

  const [bounce, setBounce] = useState(null);
  const [rowId, setRowId] = useState("");

  const handleSearchTry = (event, filterName) => {
    setSearchValue(event.target.value);
    clearTimeout(bounce);
    let temp_bounce = setTimeout(() => {
      setFilters((data) => {
        return { ...data, [filterName]: event.target.value };
      });
    }, 300);
    setBounce(temp_bounce);
  };

  const handleSearch = (event, filterName) => {
    clearTimeout(bounce);
    let temp_bounce = setTimeout(() => {
      setFilters((data) => {
        return { ...data, [filterName]: event.target.value };
      });
    }, 300);
    setBounce(temp_bounce);
  };
  const handleRowClick = (data, key) => {
    setRowId(data);
    setOpenModal(true);
  };
  const handleClose = () => {
    setOpenModal(false);
  };
  const handleDelete = () => {
    const postData = {
      user_id: rowId.user_id,
    };
    setLoading(true);
    service
      .create(deleteUser, postData)
      .then((res) => {
        setLoading(false);
        ShowAlert({
          icon: "success",
          text: res.data.message,
          width: "400px",
        });
        setOpenModal(false);
        setRender(!render);
      })
      .catch((error) => {
        setLoading(false);
        ShowAlert({
          icon: "error",
          text: error.response.data.message,
          width: "400px",
        });
        setOpenModal(false);
      });
  };

  const handleStateData = () => {
    setLoading(true);
    service
      .get(getState)
      .then((res) => {
        setLoading(false);
        setStateData(res.data.result.list_state);
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  const handleUserStatusData = () => {
    setLoading(true);
    service
      .get(getUserStatus)
      .then((res) => {
        setLoading(false);
        setUserStatus(res.data.result.list_user_status);
      })
      .catch((error) => {
        setLoading(false);
      });
  };
  const handleUserRefresh = () => {
    const postData = {
      search_string: "",
      user_id: userId,
      page: 1,
      per_page: 25,
      start_date: "",
      end_date: "",
      status: defaultStatus,
      state_id: 0
    };

    service.create(getUserDetails, postData).then((res) => {
      setUser(res?.data?.result?.list[0]);
    });
  }; useEffect(() => { }, [rowId]);
    const restrictUser = useSelector((state) => state.auth.user);
  
  const handleRedenderTable = () => {
    setRender(!render);
  };
  return (
    <div>
      <Loading open={loading} />
      <ToggleDrawer
        drawerWidth="600px"
        isOpen={isOpen && user}
        anchor="right"
        onClose={toggleDrawer(false)}
        content={
          <CreateUser
            action="edit"
            setIsOpen={setIsOpen}
            user={user}
            handleRedenderTable={handleRedenderTable}
            handleUserRefresh={handleUserRefresh}
          />
        }
      />
      <div className={classes.body}>
        <div className={classes.heading}>User List</div>
        <div className={classes.selectStyle}>
          {restrictUser?.role_id === 11 &&  <CustomSelect
            name="state"
            control={control}
            defaultValue=""
            displayValue="label"
            listItems={
              stateData.length
                ? stateData?.map((item) => ({
                  value: item.state_id,
                  label: item.state_name,
                }))
                : []
            }
            placeholder="Select"
            keyValue="value"
            height="45px"
            width="100%"
            inputRef={register("state", {
              required: false,
            })}
            handleChange={(e) => handleSearch(e, 'state_id')}
          />}
          <CustomSelect
            name="status"
            control={control}
            defaultValue=""
            listItems={userStatus}
            placeholder="Status"
            keyValue="user_status_name"
            displayValue="user_status_name"
            height="45px"
            width="100%"
            inputRef={register("status", {
              required: false,
            })}
            handleChange={(e) => handleSearch(e, 'status')}
          />

          <Input
            name="searchListUser"
            type="text"
            id="searchListUser"
            borderRadius="8px"
            backgroundColor="white"
            color="#707EAE"
            width="100%"
            height="45px"
            placeholder="Enter Here"
            value={searchValue} // Set the input value from searchValue state
            inputRef={register("searchListUser", {
              required: true,
              onChange: (e) => handleSearchTry(e, 'search_string'),
            })}

            searchIcon={true}
          />
        </div>
      </div>
      <CommonTable
        queryString={""}
        paginationData={paginationData}
        loadedFrom={"Country"}
        apiEndpoint={getUserDetails}
        searchKey={"search"}
        searchValue={searchValue}
        filter_data={filters}
        colsData={columns}
        getRowId={handleRowClick}
        paginationRequired={props.hide ? false : true}
        statusName="countryStatus"
        // hide={props.hide}
        noDataMessage="No Users Available"
        setPaginationData={setPaginationData}
        setTableData={setTableData}
        render={render}
        setOpen={setIsOpen}
        setUserId={(id) => {
          setUserId(id)
        }}
      />
      <CustomModal
        open={openModal}
        handleClose={handleClose}
        modalTitleRequired={true}
        width="380px"
        height="auto"
        modalTitle={
          <div className={classes.font}>
            {" "}
            Are you sure you want to {rowId.user_status_id === 1 ? "InActive" : "Active"}  the user{" "}
            <span className={classes.color}>{rowId.FName}</span> ?
          </div>
        }
        modalContent={
          <div className={classes.alignment}>
            <ActionButton
              variant="text"
              padding="10px 30px"
              borderRadius="8px"
              backgroundColor="red"
              color="white"
              buttonText="Yes"
              width="30%"
              handleSubmit={handleDelete}
            />
            <ActionButton
              variant="text"
              padding="10px 30px"
              borderRadius="8px"
              backgroundColor="#0FA5D9"
              color="white"
              buttonText="No"
              width="30%"
              handleSubmit={handleClose}
            />
          </div>
        }
      />
    </div>
  );
}
